<template>
<div class="menuticket">
  <table>
    <thead>
      <tr><td colspan="3">Menu: {{ classe }} {{ pour }} {{ offert }}</td></tr>
    </thead>
    <tr><td>V<span class="count">{{ numViandes }}</span><td>{{ shortCounted(menu.viandes) }}</td><td>{{ cout.prixViandes }}</td></tr>
    <tr><td>S<span class="count">{{ menu.sauces.length }}</span><td>{{ short(menu.sauces) }}</td><td>{{ cout.prixSauces }}</td></tr>
    <tr><td>p<span class="count">{{ menu.pain.length }}</span><td>{{ short(menu.pain) }}</td><td>{{ cout.prixPain }}</td></tr>
    <tr><td>c<span class="count">{{ menu.condiments.length }}</span><td>{{ short(menu.condiments) }}</td><td>{{ cout.prixCondiments }}</td></tr>
    <tr><td>l<span class="count">{{ menu.legumes.length }}</span><td>{{ short(menu.legumes) }}</td><td>{{ cout.prixLegumes }}</td></tr>
    <tr><td>f<span class="count">{{ menu.fromages.length }}</span><td>{{ short(menu.fromages) }}</td><td>{{ cout.prixFromages }}</td></tr>
    <tr><td>b<span class="count">{{ menu.bobos.length }}</span><td>{{ short(menu.bobos) }}</td><td>{{ cout.prixBobos }}</td></tr>
    <tr><td>B<span class="count">{{ numBoissons }}</span><td>{{ shortCounted(menu.boissons) }}</td><td>{{ cout.prixBoissons}}</td></tr>
    <tfoot>
      <tr><td colspan="2">total:</td><td>{{ cout.total }}</td></tr>
    </tfoot>
  </table>
</div>
</template>
<script>

import { showNoms } from '@/models/model.js'
import { price, classe, } from '@/models/menu.js'
import { mappedCompte, shortCounted } from '@/lib/counted.js'

export default {
       name: 'ticket-menu',
       props: {'menu': { type: Object, required: true } },
       methods: {
         short (items) { return showNoms(items) },
         shortCounted (b) { return shortCounted(b) },
       },
       computed: {
         offert () { return this.menu.offert ? " - OFFERT" : "" },
         pour () { return this.menu.nom ? ` - pour ${this.menu.nom}` : "" },
         classe () { return classe(this.menu); },
         cout   () { return price(this.menu); },
         numViandes () { return mappedCompte(this.menu.viandes) },
         numBoissons () { return mappedCompte(this.menu.boissons) },
       },
}
</script>
<style>
.menuticket {
  margin-top: 1em;
}

.menuticket table td:first-child {
width: 10%;
}

.menuticket table thead td {
text-align: left !important;
}

.menuticket table td:last-child {
width: 15%;
}


.menuticket table tfoot, .menuticket table thead {
font-weight: bold;
}

.menuticket td { position: relative; }
.menuticket .count { font-size: 7pt; position: absolute; top: 0px }

</style>
